import {
  MSG_DELETE_WARNING,
  MSG_UNDO_DELETE_WARNING,
  MSG_RECORD_CREATE,
  MSG_RECORD_UPDATE,
  MSG_RECORD_DELETE,
  MSG_RECORD_UNDO,
  MIN_TEXT_LENGTH,
  MAX_TEXT_LENGTH,
} from "constants/common";

//vmware solution type
export const METHOD_VMWARE_SOLUTION_TYPE_LIST = "vmwaresolutiontype/pageable/";
export const METHOD_VMWARE_SOLUTION_TYPE_CREATE = "vmwaresolutiontype/";
export const METHOD_VMWARE_SOLUTION_TYPE_UPDATE = "vmwaresolutiontype/{ID}/";
export const METHOD_VMWARE_SOLUTION_TYPE_DELETE = "vmwaresolutiontype/{ID}/";
export const METHOD_VMWARE_SOLUTION_TYPE_DETAIL = "vmwaresolutiontype/{ID}/";

//UCP Release Version
export const METHOD_UCP_RELEASE_VERSION_LIST = "ucpreleaseversion/pageable/";
export const METHOD_UCP_RELEASE_VERSION_CREATE = "ucpreleaseversion/";
export const METHOD_UCP_RELEASE_VERSION_UPDATE = "ucpreleaseversion/{ID}/";
export const METHOD_UCP_RELEASE_VERSION_DELETE = "ucpreleaseversion/{ID}/";
export const METHOD_UCP_RELEASE_VERSION_DETAIL = "ucpreleaseversion/{ID}/";

//VMware VCF Version
export const METHOD_VMWARE_VCF_VERSION_LIST = "vmwarevcfversion/pageable/";
export const METHOD_VMWARE_VCF_VERSION_CREATE = "vmwarevcfversion/";
export const METHOD_VMWARE_VCF_VERSION_UPDATE = "vmwarevcfversion/{ID}/";
export const METHOD_VMWARE_VCF_VERSION_DELETE = "vmwarevcfversion/{ID}/";
export const METHOD_VMWARE_VCF_VERSION_DETAIL = "vmwarevcfversion/{ID}/";

//MANAGEMENT SOFTWARE VERSION
export const METHOD_MANAGEMENT_SOFTWARE_VERSION_LIST =
  "managementsoftwareversion/pageable/";
export const METHOD_MANAGEMENT_SOFTWARE_VERSION_CREATE =
  "managementsoftwareversion/";
export const METHOD_MANAGEMENT_SOFTWARE_VERSION_UPDATE =
  "managementsoftwareversion/{ID}/";
export const METHOD_MANAGEMENT_SOFTWARE_VERSION_DELETE =
  "managementsoftwareversion/{ID}/";
export const METHOD_MANAGEMENT_SOFTWARE_VERSION_DETAIL =
  "managementsoftwareversion/{ID}/";

// MASTER MAPPING
export const METHOD_VMWAREMAPPER_LIST = "vmwaremapperlist/{masterId}/";
export const METHOD_VMWARE_COMBINE_KEY_CREATE = "vmwaremapper/1/0/";
export const METHOD_VMWARE_COMBINE_KEY_DELETE = "vmwaremapper/1/{ID}/0/";
// cpld
export const METHOD_CPLD_MAPPING_KEY_CREATE = "vmwaremapper/4/0/";
export const METHOD_CPLD_MAPPING_KEY_DETAILS = "vmwaremapper/4/{ID}/";
export const METHOD_CPLD_MAPPING_KEY_UPDATE = "vmwaremapper/4/{ID}/";
export const METHOD_CPLD_MAPPING_KEY_DELETE = "vmwaremapper/4/{ID}/0/";

// cpu generation
export const METHOD_CPU_GEN_MAPPING_KEY_CREATE = "vmwaremapper/5/0/";
export const METHOD_CPU_GEN_MAPPING_KEY_DETAILS = "vmwaremapper/5/{ID}/";
export const METHOD_CPU_GEN_MAPPING_KEY_UPDATE = "vmwaremapper/5/{ID}/";
export const METHOD_CPU_GEN_MAPPING_KEY_DELETE = "vmwaremapper/5/{ID}/0/";

// drive
export const METHOD_DRIVE_MAPPING_KEY_CREATE = "vmwaremapper/6/0/";
export const METHOD_DRIVE_MAPPING_KEY_DETAILS = "vmwaremapper/6/{ID}/";
export const METHOD_DRIVE_MAPPING_KEY_UPDATE = "vmwaremapper/6/{ID}/";
export const METHOD_DRIVE_MAPPING_KEY_DELETE = "vmwaremapper/6/{ID}/0/";

// switch firmware
export const METHOD_FIRMWARE_BY_SWITCH =
  "vmwaremapper/switchfirmware/{product_id}/{switch_id}/";

// fc switch
export const METHOD_FC_SWITCH_MAPPING_KEY_CREATE = "vmwaremapper/8/0/";
export const METHOD_FC_SWITCH_MAPPING_KEY_DETAILS = "vmwaremapper/8/{ID}/";
export const METHOD_FC_SWITCH_MAPPING_KEY_DELETE = "vmwaremapper/8/{ID}/0";

// leaf switch
export const METHOD_LEAF_SWITCH_MAPPING_KEY_CREATE = "vmwaremapper/11/0/";
export const METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS = "vmwaremapper/11/{ID}/";
export const METHOD_LEAF_SWITCH_MAPPING_KEY_DELETE = "vmwaremapper/11/{ID}/0";

// spine switch
export const METHOD_SPINE_SWITCH_MAPPING_KEY_CREATE = "vmwaremapper/16/0/";
export const METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS = "vmwaremapper/16/{ID}/";
export const METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE = "vmwaremapper/16/{ID}/0";

// management switch
export const METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_CREATE = "vmwaremapper/12/0/";
export const METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS =
  "vmwaremapper/12/{ID}/";
export const METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DELETE =
  "vmwaremapper/12/{ID}/0";

// gpu
export const METHOD_GPU_MAPPING_KEY_CREATE = "vmwaremapper/9/0/";
export const METHOD_GPU_MAPPING_KEY_DETAILS = "vmwaremapper/9/{ID}/";
export const METHOD_GPU_MAPPING_KEY_DELETE = "vmwaremapper/9/{ID}/0";
// hba
export const METHOD_HBA_MAPPING_KEY_CREATE = "vmwaremapper/10/0/";
export const METHOD_HBA_MAPPING_KEY_DETAILS = "vmwaremapper/10/{ID}/";
export const METHOD_HBA_MAPPING_KEY_UPDATE = "vmwaremapper/10/{ID}/";
export const METHOD_HBA_MAPPING_KEY_DELETE = "vmwaremapper/10/{ID}/0/";

// controller
export const METHOD_CONTROLLER_MAPPING_KEY_CREATE = "vmwaremapper/3/0/";
export const METHOD_CONTROLLER_MAPPING_KEY_DETAILS = "vmwaremapper/3/{ID}/";
export const METHOD_CONTROLLER_MAPPING_KEY_UPDATE = "vmwaremapper/3/{ID}/";
export const METHOD_CONTROLLER_MAPPING_KEY_DELETE = "vmwaremapper/3/{ID}/0/";

// pmem
export const METHOD_PMEM_MAPPING_KEY_CREATE = 'vmwaremapper/15/0/';
export const METHOD_PMEM_MAPPING_KEY_DETAILS = 'vmwaremapper/15/{ID}/';
export const METHOD_PMEM_MAPPING_KEY_DELETE= 'vmwaremapper/15/{ID}/0';

// block storage
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_CREATE = "vmwaremapper/2/0/";
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_DETAILS = "vmwaremapper/2/{ID}/";
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_UPDATE = "vmwaremapper/2/{ID}/";
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_DELETE = "vmwaremapper/2/{ID}/0/";
// nic
export const METHOD_NIC_MAPPING_KEY_CREATE = 'vmwaremapper/13/0/';
export const METHOD_NIC_MAPPING_KEY_DETAILS = 'vmwaremapper/13/{ID}/';
export const METHOD_NIC_MAPPING_KEY_DELETE= 'vmwaremapper/13/{ID}/0';

// bios bmc
export const METHOD_BIOS_MAPPING_KEY_CREATE = 'vmwaremapper/17/0/';
export const METHOD_BIOS_MAPPING_KEY_DETAILS = 'vmwaremapper/17/{ID}/';
export const METHOD_BIOS_MAPPING_KEY_DELETE= 'vmwaremapper/17/{ID}/0';


export const METHOD_EXTRA_MAPPING_KEY_CREATE = 'vmwaremapper/7/0/';
export const METHOD_EXTRA_MAPPING_KEY_DETAILS = 'vmwaremapper/7/{ID}/';
export const METHOD_EXTRA_MAPPING_KEY_DELETE= 'vmwaremapper/7/{ID}/0';


export const METHOD_OS_MAPPING_KEY_CREATE = 'vmwaremapper/14/0/';
export const METHOD_OS_MAPPING_KEY_DETAILS = 'vmwaremapper/14/{ID}/';
export const METHOD_OS_MAPPING_KEY_DELETE= 'vmwaremapper/14/{ID}/0';

//text box length
export const TEXT_MIN_LENGTH = MIN_TEXT_LENGTH;
export const TEXT_MAX_LENGTH = MAX_TEXT_LENGTH;

//language constants
export const MSG_WARNING_DELETE = MSG_DELETE_WARNING;
export const MSG_WARNING_UNDO_DELETE = MSG_UNDO_DELETE_WARNING;
export const MSG_CREATE_RECORD = MSG_RECORD_CREATE;
export const MSG_UPDATE_RECORD = MSG_RECORD_UPDATE;
export const MSG_DELETE_RECORD = MSG_RECORD_DELETE;
export const MSG_UNDO_RECORD = MSG_RECORD_UNDO;

// generic error template

export const MSG_COMBINE_KEY_WARNING =
  "Please select at least one combine key from the dropdown!";
export const MSG_MAPPING_DELETE_WARNING = "Are you sure you want to remove ";
export const MSG_MAPPING_RESTORE_WARNING = "Are you sure you want to restore ";
export const MAPPING_SELECT_ERROR_TEMPLATE = "Please select _FIELD_NAME_!";
export const MAPPING_INPUT_ERROR_TEMPLATE = "Please enter _FIELD_NAME_!";
